import React from 'react';

const PasswordStrengthMeter = ({ password }) => {
  const calculateStrength = (password) => {
    if (!password) return { score: 0, label: '', color: 'bg-gray-200' };
    
    let score = 0;
    if (password.length >= 6) score += 1;
    if (password.length >= 8) score += 1;
    if (/[a-z]/.test(password)) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;
    
    const percentage = (score / 6) * 100;
    
    let label = '';
    let color = '';
    
    if (score <= 1) {
      label = 'Very Weak';
      color = 'bg-red-500';
    } else if (score <= 2) {
      label = 'Weak';
      color = 'bg-orange-500';
    } else if (score <= 3) {
      label = 'Fair';
      color = 'bg-yellow-500';
    } else if (score <= 4) {
      label = 'Good';
      color = 'bg-blue-500';
    } else {
      label = 'Strong';
      color = 'bg-green-500';
    }
    
    return { score, label, color, percentage };
  };

  const strength = calculateStrength(password);

  return (
    <div className="mt-1">
      <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
        <span>Password Strength:</span>
        <span className="font-medium">{strength.label}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div 
          className={`h-2 rounded-full transition-all duration-300 ${strength.color}`}
          style={{ width: `${strength.percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default PasswordStrengthMeter; 